export default __webpack_public_path__ + "54cbbe104525b0319eafc04198a8e774.png";